import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'

export function ProtectedRoute({ requireMfa = true }) {
  const { user, loading, mfaEnabled, requireMfa: mfaEnforced } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-100 via-sky-50 to-slate-200">
        <p className="text-brand-muted">Loading…</p>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  const mustChange = Boolean(user.must_change_password)
  if (mustChange && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />
  }

  if (
    requireMfa &&
    mfaEnforced &&
    !mfaEnabled &&
    !mustChange &&
    location.pathname !== '/mfa/setup'
  ) {
    return <Navigate to="/mfa/setup" replace />
  }

  return <Outlet />
}
